import { render, staticRenderFns } from "./DialogAside.vue?vue&type=template&id=06a56cb6&"
import script from "./DialogAside.vue?vue&type=script&lang=js&"
export * from "./DialogAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports